// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run pnpm gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MyLoyaltyStatusSidebarSubscriptionVariables = Types.Exact<{
  input: Types.LoyaltyPublicMyStatusUpdatedInput;
}>;


export type MyLoyaltyStatusSidebarSubscription = { __typename?: 'Subscription', loyaltyPublicMyStatusUpdated?: { __typename?: 'LoyaltyPublicMyStatusUpdatedPayload', clientSubscriptionId?: string, myStatus?: { __typename?: 'LoyaltyPublicMyStatus', id?: string, tierPoints?: number, currentTier?: { __typename?: 'LoyaltyPublicUserTier', id: string, logoUrl?: string }, nextMilestone?: { __typename?: 'LoyaltyPublicMilestone', id: string, points?: string, progress?: number } } } };


export const MyLoyaltyStatusSidebarSubscriptionDocument = /*#__PURE__*/ gql`
    subscription MyLoyaltyStatusSidebarSubscription($input: LoyaltyPublicMyStatusUpdatedInput!) {
  loyaltyPublicMyStatusUpdated(input: $input) {
    myStatus {
      id
      tierPoints
      currentTier {
        id
        logoUrl
      }
      nextMilestone {
        id
        points
        progress
      }
    }
    clientSubscriptionId
  }
}
    `;
export function useMyLoyaltyStatusSidebarSubscription(baseOptions: Apollo.SubscriptionHookOptions<MyLoyaltyStatusSidebarSubscription, MyLoyaltyStatusSidebarSubscriptionVariables> & ({ variables: MyLoyaltyStatusSidebarSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<MyLoyaltyStatusSidebarSubscription, MyLoyaltyStatusSidebarSubscriptionVariables>(MyLoyaltyStatusSidebarSubscriptionDocument, options);
      }
export type MyLoyaltyStatusSidebarSubscriptionHookResult = ReturnType<typeof useMyLoyaltyStatusSidebarSubscription>;
export type MyLoyaltyStatusSidebarSubscriptionSubscriptionResult = Apollo.SubscriptionResult<MyLoyaltyStatusSidebarSubscription>;